import React from 'react';
import {toast} from 'react-toastify';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import "./ModalLoginCss.css"
import "./LoginMain.css"
import "./LoginUtil.css"
import Utils from "../../utils/utils";
import {withRouter} from "../../utils/withRouter";
import ModalForgotPassword from "../admin/profile/modalForgotPassword";
import ModalForgotPassword3 from "../admin/profile/modalForgotPassword3";
import ModalForgotPassword2 from "../admin/profile/modalForgotPassword2";
import UserController from "../../services/system/user/user-controller";
import {setAccessToken} from "../../utils/authority";
const eye = <FontAwesomeIcon icon={faEye} />;
class AuthSas extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            open: false,
            anyValue: '',
            username: '',
            password: '',
            showPassword: false,
            remember: false,
            showForgotPassword: false,
        };
        this.errors = {};
        this.onShow = this.onShow.bind(this)
    }

    handleLoginClick = (e) => {
        e.preventDefault();
        this.submit();
    };
    submit = (e) => {
        let payload = {
            username: this.state.username,
            password: this.state.password
        };
        UserController.login(payload, res => {
            if (!res.success) {
                toast.error("Đăng nhập không thành công")
            } else {
                let day = this.state.remember ? 7 : 1;
                setAccessToken(res.data.token, day);
                localStorage.setItem("username", this.state.username);
                this.getMyPermission();
            }
        }).catch((error) => {
            toast.error("Đăng nhập không thành công")
        })
    };
    getMyPermission(){
        UserController.getPermission(res => {
            if (!res.success) {
                toast.error("Lỗi lấy danh sách")
            } else {
                res.data.push("ACCOUNT_EDIT_PROFILE")
                res.data.push("ACCOUNT_CHANGE_PWD")
                res.data.push("ACCOUNT_FORGOT_PWD")
                localStorage.setItem("sas_school_per", JSON.stringify(res.data));
                setTimeout(() => {
                    this.props.navigate('/ad-sas-school/quan-ly-thong-tin-ca-nhan');
                    window.location.reload()
                }, 1000)
            }
        }).catch((error) => {
            toast.error("Lỗi lấy danh sách")
        })
    }
    keyPress = (event, input) => {
        if (event.keyCode === 13) {
            if (input === 'enter') {
                return this.submit();
            } else {
                // input.focus();
            }
        }
    };

    onShow = (e) => {
        this.setState({
            anyValue: '',
            password: '',
            remember: false
        });
    };
    showModalForgot = () => {
        this.setState({
            modalForgotPassword: true
        });
    };

    onCloseModalForgotPassword = () => {
        this.setState({
            modalForgotPassword: false
        })
    };
    showModalForgotPassword3 = (token, phone) => {
        this.setState({
            modalForgotPassword: false,
            modalForgotPassword3: true,
            tokenForgotPass: token,
            phoneNumberForgot: phone
        })
    };
    onCloseModalForgotPassword3 = (open2) => {
        this.setState({
            modalForgotPassword3: false,
        });
        if(open2) {
            this.setState({
                modalForgotPassword2: true,
            })
        }
        // toast.success("Chúng tôi đã gửi đường dẫn vào email của bạn. Vui lòng kiểm tra email!")
    };

    render() {
        const togglePasswordVisiblity = () => {
            this.setState({showPassword: !this.state.showPassword});
        };
        return (
            <div>
                <div className="limiter">
                    <div className="container-login100" style={{backgroundImage: 'url("images/bg_times.png")'}}>
                        <div className="wrap-login100">
                            <form className="login100-form validate-form">
                                    <span className="login100-form-logo">
                                        <div className='justify-center img-logo-wrapper' style={{width:"72%", height: "100%", textAlign: 'center', backgroundImage: `url("/images/logo_sas.png")`}} />
                                    </span>
                                    <span className="login100-form-title p-b-34 p-t-27">
                                      Đăng nhập
                                    </span>
                                    <div className="wrap-input100 validate-input" data-validate="Tên đăng nhập">
                                        <input
                                            placeholder="Tên đăng nhập"
                                            maxLength={255}
                                            type="text"
                                            className="input100"
                                            value={this.state.username}
                                            onKeyDown={event => this.keyPress(event, this.loginInput)}
                                            onChange={e => this.setState({username: Utils.filterNormalCharacter(e.target.value).trim()})}
                                        />
                                        {/*<span className="focus-input100" data-placeholder="Tên đăng nhập"/>*/}
                                    </div>
                                    <div className="wrap-input100 validate-input" data-validate="Enter password">
                                        <input
                                            placeholder="Mật khẩu"
                                            maxLength={255}
                                            type={this.state.showPassword ? "text" : "password"}
                                            className="input100"
                                            value={this.state.password}
                                            onKeyDown={event => this.keyPress(event, 'enter')}
                                            onChange={e => this.setState({password: e.target.value})}
                                        />
                                        <i className="hidePassword" onClick={togglePasswordVisiblity}>{eye}</i>{" "}
                                    </div>
                                    <div className="contact100-form-checkbox">
                                        <input
                                            type="checkbox"
                                            onChange={(e) => {
                                                const value = this.state.remember;
                                                this.setState({remember: !value});
                                            }}
                                            checked={this.state.remember}
                                        />
                                        <label className="label-checkbox100" htmlFor="ckb1">
                                            Nhớ mật khẩu
                                        </label>
                                    </div>
                                    <div className="container-login100-form-btn">
                                        <button className="login100-form-btn"  onClick={this.handleLoginClick}>
                                            Đăng nhập
                                        </button>
                                    </div>
                                    <div className="text-center p-t-90">
                                        <a
                                            href="#"
                                            className="txt1"
                                            aria-label="Close"
                                            onClick={this.showModalForgot}>
                                            Quên mật khẩu ?
                                        </a>
                                    </div>
                            </form>
                        </div>
                    </div>
                </div>
                {this.state.modalForgotPassword && <ModalForgotPassword show={this.state.modalForgotPassword}
                                                                        setData={this.showModalForgotPassword3}
                                                                        onHideModal={this.onCloseModalForgotPassword}/>}
                {this.state.modalForgotPassword3 && <ModalForgotPassword3 show={this.state.modalForgotPassword3}
                                                                          onHideModal={(open2) => {
                                                                              this.onCloseModalForgotPassword3(open2);
                                                                          }}
                                                                          saveOtp={(tokenForgotPass, otp) => {
                                                                              this.saveOtp(tokenForgotPass, otp)
                                                                          }}
                                                                          token={this.state.tokenForgotPass}
                                                                          name={this.state.phoneNumberForgot}
                />}
                {this.state.modalForgotPassword2 && <ModalForgotPassword2 show={this.state.modalForgotPassword2}
                                                                          onHideModal={() => {
                                                                              this.onCloseModalForgotPassword2();
                                                                          }}
                                                                          otp={this.state.otp}
                                                                          token={this.state.tokenForgotPass}
                                                                          name={this.state.phoneNumberForgot}
                />}
            </div>
        );
    }
}
export default withRouter(AuthSas)